import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import {
  APP_STATUS,
  useTemplatesContext,
} from '@components/Contexts/TemplatesContext';
import { useShallowRouter } from '@components/Hooks/useRouter';
import { updateQueryParams } from '@utils/route';
import NoResultsErrorState from '../../ErrorStates/NoResultsErrorState';
import GenericErrorState from '../../ErrorStates/GenericErrorState';
import s from '../TemplateGallery.module.scss';
import GalleryGridMobile from '../GalleryGridMobile';
import { useInfiniteTemplatesQuery } from '@components/Hooks/useInfiniteTemplatesQuery';

function ErrorState({ showEmptyError }: { showEmptyError?: Boolean }) {
  const { navigate, router } = useShallowRouter();
  const clearAll = () => {
    navigate(
      updateQueryParams({}, router, {
        all: true,
      }),
      false,
    );
    setTimeout(() => window.location.reload(), 0);
  };

  return showEmptyError ? (
    <NoResultsErrorState isMobileView={true} />
  ) : (
    <GenericErrorState overrideAction={clearAll} />
  );
}

const TemplateGalleryMobile: FC = () => {
  const {
    state: { filters, sort, appStatus },
  } = useTemplatesContext();
  const { data, hasNextPage, fetchNextPage } = useInfiniteTemplatesQuery(
    filters,
    sort,
  );

  const showGeneralError = appStatus === APP_STATUS.ERROR;
  const showEmptyError = data?.pages?.[0]?.count === 0;

  return (
    <Box
      dataHook="templates-gallery-mobile-container"
      height="100%"
      minHeight="calc(100vh - 295px)"
      direction="vertical"
    >
      {showEmptyError || showGeneralError ? (
        <ErrorState showEmptyError={showEmptyError} />
      ) : (
        <Box
          dataHook="templates-gallery-mobile"
          direction="vertical"
          className={`${s.templateGalleryContainer} ${s.mobileView}`}
        >
          <GalleryGridMobile
            templatesPages={data}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
          />
        </Box>
      )}
    </Box>
  );
};

export default TemplateGalleryMobile;
